import { render, staticRenderFns } from "./ReferentielVarieteView.vue?vue&type=template&id=05980c05"
import script from "./ReferentielVarieteView.vue?vue&type=script&lang=js"
export * from "./ReferentielVarieteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports